import DownloadIcon from '@mui/icons-material/Download';
import {
  IconButton,
} from "@mui/material";
import { forwardRef, useState } from "react";

type FileResult = { text: string, fileType: string, fileName: string };

const downloadString = ({text, fileType, fileName}: FileResult) => {
  const blob = new Blob([text], { type: fileType });

  const a = document.createElement("a");
  a.download = fileName;
  a.href = URL.createObjectURL(blob);
  a.dataset.downloadurl = [fileType, a.download, a.href].join(":");
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(function() { URL.revokeObjectURL(a.href); }, 1500);
}

type Props = {
  fetch: () => Promise<FileResult | undefined>;
}

const DownloadButton = forwardRef(({ fetch, ...props }: Props, ref) => {
  const [loading, setLoading] = useState(false);
  return <IconButton {...props} ref={ref as any} disabled={loading} onClick={async () => {
    setLoading(true);
    const result = await fetch();
    if (result) {
      downloadString(result);
    }
    setLoading(false);
  }}>
    <DownloadIcon sx={{ fontSize: 16 }} />
  </IconButton>
});

export default DownloadButton;
